export default "__VITE_ASSET__D68PFjTO__"